import React, { useEffect, useState } from "react";
import { CirclePicker } from "react-color";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../components/alerts";
import medicGeekApi from "../../../config/axiosConfig";
import "./../../../styles/FormPro.css";

const PaletaColor = ({ currentForm }) => {
  const [paletaColors, setPaletaColors] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const paletaColorsPerPage = 10;
  const [selectedPaletaColorLocal, setSelectedPaletaColorLocal] =
    useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [formulario, setFormulario] = useState({
    colorName: "",
    colorRgb: "rgb(255, 0, 0)",
    estatusColor: "activo",
  });
  const [colorPickerVisible, setColorPickerVisible] = useState(false);

  const predefinedColors = [
    "#e91e63",
    "#9c27b0",
    "#673ab7",
    "#3f51b5",
    "#1171ef",
    "#2196f3",
    "#03a9f4",
    "#00bcd4",
    "#009688",
    "#4caf50",
    "#8bc34a",
    "#cddc39",
    "#ffeb3b",
    "#ffc107",
    "#ff9800",
    "#ff5722",
    "#795548",
    "#607d8b",
  ];

  const openModal = (paletaColor) => {
    setSelectedPaletaColorLocal(paletaColor);

    if (paletaColor) {
      setIsEditing(true);
      setFormulario({
        colorId: paletaColor.colorId,
        colorName: paletaColor.colorName,
        colorRgb: paletaColor.colorRgb,
        estatusColor: paletaColor.estatus ? "activo" : "inactivo",
      });
    } else {
      setIsEditing(false); // Establecer como modo creación cuando se abre el modal para crear uno nuevo
      // Limpia los campos si es necesario
      setFormulario({
        colorName: "",
        colorRgb: "",
        estatusColor: "activo",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    // selectedPaletaColorLocal(null);
    setIsEditing(false);
    setModalOpen(false);
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm]);

  const fetchData = async () => {
    setLoading(true); // Iniciar la carga
    try {
      const response = await medicGeekApi.get(
        `/paletaColors?search=${searchTerm}`,
        {
          params: {
            $or: [
              { colorName: { $regex: searchTerm, $options: "i" } },
              { colorRgb: { $regex: searchTerm, $options: "i" } },
            ],
          },
        }
      );
      const sortedPaletaColors = response.data.sort(
        (a, b) => a.colorId - b.colorId
      );

      setPaletaColors(sortedPaletaColors);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Finalizar carga
    }
  };

  const pageCount = Math.ceil(paletaColors.length / paletaColorsPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedPaletaColors = paletaColors
    .filter((paletaColor) => {
      return (
        (paletaColor.colorName &&
          paletaColor.colorName
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (paletaColor.colorRgb &&
          paletaColor.colorRgb.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    })
    .slice(
      pageNumber * paletaColorsPerPage,
      (pageNumber + 1) * paletaColorsPerPage
    );

  const updatePaletaColorsList = () => {
    medicGeekApi
      .get("/paletaColors")
      .then((response) => {
        setPaletaColors(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // Función para manejar la visibilidad del ColorPicker
  const toggleColorPicker = () => {
    setColorPickerVisible(!colorPickerVisible);
  };
  // Función para manejar la selección de color desde el ColorPicker
  const handleColorChange = (color) => {
    setFormulario({ ...formulario, colorRgb: color.hex }); // Usamos color.hex para obtener el valor de color en formato de cadena (por ejemplo, "#RRGGBB")
    setColorPickerVisible(false);
  };

  const saveColor = () => {
    const nuevoColor = {
      colorName: document.getElementById("colorName").value,
      colorRgb: document.getElementById("colorRgb").value,
      estatus:
        document.getElementById("estatusColor").value === "activo"
          ? "Activo"
          : "Inactivo",
    };

    medicGeekApi
      .post("/paletaColors", nuevoColor)
      .then((response) => {
        showSuccessAlert("Color creado con éxito.", 3000);
        closeModal();
        fetchData();
      })
      .catch((error) => {
        showErrorAlert("Error al crear el Color.", 3000);
      });
  };

  const editColor = () => {
    if (selectedPaletaColorLocal && selectedPaletaColorLocal.colorId) {
      const { colorId } = selectedPaletaColorLocal;
      const colorName = document.getElementById("colorName").value;
      const colorRgb = document.getElementById("colorRgb").value;
      const estatusColor =
        document.getElementById("estatusColor").value === "activo"
          ? "Activo"
          : "Inactivo";

      const updatedPaletaColor = {
        colorId,
        colorName: colorName,
        colorRgb: colorRgb,
        estatus: estatusColor,
      };

      medicGeekApi
        .patch(`/paletaColors/${colorId}`, updatedPaletaColor)
        .then((response) => {
          showSuccessEditAlert("Color Actualizado con éxito.", 3000);
          closeModal();
          fetchData();
        })
        .catch((error) => {
          showErrorAlert("Error al actualizar el Color.", 3000);
        });
    } else {
      showErrorAlert("No se puede actualizar: Color no válido.");
    }
  };

  const deleteColor = () => {
    if (formulario && formulario.colorId) {
      const { colorId } = formulario;


      medicGeekApi
        .delete(`/paletaColors/${colorId}`)
        .then((response) => {
          showSuccessAlert("Color eliminado con éxito.", 3000);
          console.log(response.data);
          closeModal();
          updatePaletaColorsList();
        })
        .catch((error) => {
          showErrorAlert("Error al eliminar el Color.", 3000);
        });
    } else {
      showErrorAlert("No se puede eliminar: Color no válido.", 3000);
    }
  };

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
    </tr>
  );

  return (
  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">

        <h2 className="pro-title">
          Paleta de Colores
        </h2>

        <p className="pro-subtitle">
          Gestión y mantenimiento de colores
        </p>

      </div>

      <div className="pro-actions">

        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar color..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

        <button
          type="button"
          className="pro-btn-primary"
          onClick={() => openModal(null)}
        >
          <i className="bi bi-plus-circle"></i>
          Nuevo Color
        </button>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE DESKTOP */}
    {/* ===================================================== */}

    <div className="pro-card d-none d-md-block">

      <div className="table-responsive">

        <table className="table pro-table">

          <thead>

            <tr>
              <th style={{ width: "10%" }}>ID</th>
              <th style={{ width: "30%" }}>Nombre</th>
              <th style={{ width: "25%" }}>Color</th>
              <th style={{ width: "20%" }}>Estado</th>
              <th style={{ width: "15%" }}>Acciones</th>
            </tr>

          </thead>

          <tbody>

            {loading ? (

              Array.from({ length: 15 }).map((_, index) => (
                <SkeletonTableRow key={index} />
              ))

            ) : (

              displayedPaletaColors.map((paletaColor) => (

                <tr key={paletaColor.colorId}>

                  <td>
                    #{paletaColor.colorId}
                  </td>

                  <td className="fw-semibold">
                    {paletaColor.colorName}
                  </td>

                  <td>

                    <div className="d-flex align-items-center gap-3">

                      <span
                        style={{
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          backgroundColor: paletaColor.colorRgb,
                          display: "inline-block",
                          border: "2px solid #fff",
                          boxShadow: "0 0 0 1px #cbd5e1",
                        }}
                      ></span>

                      <span className="text-muted">
                        {paletaColor.colorRgb}
                      </span>

                    </div>

                  </td>

                  <td>

                    <span
                      className={`expediente-badge ${
                        paletaColor.estatus === "Activo"
                          ? ""
                          : "gender-badge"
                      }`}
                    >
                      {paletaColor.estatus}
                    </span>

                  </td>

                  <td>

                    <div className="pro-table-actions">

                      <button
                        type="button"
                        className="pro-action-btn primary"
                        title="Editar"
                        onClick={() => openModal(paletaColor)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>

                      <button
                        type="button"
                        className="pro-action-btn warning"
                        title="Eliminar"
                        onClick={deleteColor}
                      >
                        <i className="bi bi-trash"></i>
                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

    {/* ===================================================== */}
    {/* MOBILE CARDS */}
    {/* ===================================================== */}

    <div className="d-md-none">

      <div className="row">

        {loading ? (

          Array.from({ length: 5 }).map((_, index) => (

            <div className="col-12 mb-3" key={index}>

              <div className="mobile-patient-card">

                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line"></div>

              </div>

            </div>

          ))

        ) : (

          displayedPaletaColors.map((paletaColor) => (

            <div
              className="col-12 mb-3"
              key={paletaColor.colorId}
            >

              <div className="mobile-patient-card">

                <div className="mobile-card-top">

                  <div className="patient-info">

                    <div
                      className="patient-avatar"
                      style={{
                        background: paletaColor.colorRgb,
                      }}
                    >
                      🎨
                    </div>

                    <div>

                      <div className="patient-name">
                        {paletaColor.colorName}
                      </div>

                      <div className="patient-id">
                        Color #{paletaColor.colorId}
                      </div>

                    </div>

                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">
                    Código RGB
                  </small>

                  <div className="d-flex align-items-center gap-2">

                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        backgroundColor: paletaColor.colorRgb,
                        display: "inline-block",
                        border: "2px solid #fff",
                        boxShadow: "0 0 0 1px #cbd5e1",
                      }}
                    ></span>

                    <span>
                      {paletaColor.colorRgb}
                    </span>

                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">
                    Estado
                  </small>

                  <span
                    className={`expediente-badge ${
                      paletaColor.estatus === "Activo"
                        ? ""
                        : "gender-badge"
                    }`}
                  >
                    {paletaColor.estatus}
                  </span>

                </div>

                <div className="mobile-card-actions">

                  <button
                    type="button"
                    className="pro-action-btn primary"
                    onClick={() => openModal(paletaColor)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    type="button"
                    className="pro-action-btn warning"
                    onClick={deleteColor}
                  >
                    <i className="bi bi-trash"></i>
                  </button>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

    </div>

    {/* ===================================================== */}
    {/* PAGINATION */}
    {/* ===================================================== */}

    {!showForm && (

      <div className="pro-pagination">

        <nav aria-label="Page navigation example">

          <ul className="pagination modern-pagination">

            {/* PREVIOUS */}

            <li
              className={`page-item ${
                pageNumber === 0 ? "disabled" : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber - 1,
                  })
                }
                style={{
                  cursor:
                    pageNumber === 0
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <i className="bi bi-chevron-left"></i>
              </span>

            </li>

            {/* NUMBERS */}

            {Array.from(
              { length: Math.min(pageCount, 10) },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <span
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >
                    {index + 1}
                  </span>

                </li>

              )
            )}

            {/* NEXT */}

            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber + 1,
                  })
                }
                style={{
                  cursor:
                    pageNumber === pageCount - 1
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <i className="bi bi-chevron-right"></i>
              </span>

            </li>

          </ul>

        </nav>

      </div>

    )}

    {/* ===================================================== */}
    {/* MODAL */}
    {/* ===================================================== */}

    {currentForm === "paletaColorForm" &&
      selectedPaletaColorLocal && (
        <div className="main-content"></div>
      )}

    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      centered
      className="pro-modal"
    >

      <ModalHeader toggle={closeModal}>

        {isEditing
          ? "Editar Color"
          : "Nuevo Color"}

      </ModalHeader>

      <ModalBody>

        <Form>

          <FormGroup className="mb-3">

            <Label for="colorName">
              Nombre del Color
            </Label>

            <Input
              type="text"
              id="colorName"
              className="pro-input"
              value={formulario.colorName}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  colorName: e.target.value,
                })
              }
            />

          </FormGroup>

          <FormGroup className="mb-3">

            <Label for="colorRgb">
              RGB
            </Label>

            <div className="d-flex align-items-center gap-3">

              <Input
                type="text"
                id="colorRgb"
                className="pro-input"
                value={formulario.colorRgb}
                onClick={toggleColorPicker}
                readOnly
              />

              <div
                style={{
                  cursor: "pointer",
                  width: "55px",
                  height: "55px",
                  borderRadius: "16px",
                  background: formulario.colorRgb,
                  border: "2px solid #e2e8f0",
                  flexShrink: 0,
                }}
                onClick={toggleColorPicker}
              ></div>

            </div>

            {colorPickerVisible && (

              <div className="mt-4 d-flex justify-content-center">

                <CirclePicker
                  colors={predefinedColors}
                  width="100%"
                  color={formulario.colorRgb}
                  onChange={handleColorChange}
                />

              </div>

            )}

          </FormGroup>

          <FormGroup>

            <Label for="estatusColor">
              Estado
            </Label>

            <Input
              type="select"
              id="estatusColor"
              className="pro-input"
              value={formulario.estatusColor}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  estatusColor: e.target.value,
                })
              }
            >

              <option value="activo">
                Activo
              </option>

              <option value="inactivo">
                Inactivo
              </option>

            </Input>

          </FormGroup>

        </Form>

      </ModalBody>

      <ModalFooter>

        <Button
          className="pro-btn-cancel"
          onClick={closeModal}
        >
          Cancelar
        </Button>

        <Button
          className="pro-btn-save"
          onClick={isEditing ? editColor : saveColor}
        >
          {isEditing
            ? "Guardar Edición"
            : "Guardar"}
        </Button>

      </ModalFooter>

    </Modal>

  </div>
);
  
  

};
export default PaletaColor;
